export default __webpack_public_path__ + "static/media/cpp.64f63735.png";